import { exhaustMap, tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { OffshoreReportsService } from '../offshore-reports-service/offshore-reports.service';
import { offshoreReportsEvents } from './offshore-reports-events';

export function withOffshoreReportsEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      const events = inject(Events);
      const router = inject(Router);
      const offshoreReportsService = inject(OffshoreReportsService);

      return {
        fetchReports$: events.on(offshoreReportsEvents.fetchReports).pipe(
          exhaustMap(({ payload: vesselId }) =>
            offshoreReportsService.getOffshoreReports(vesselId).pipe(
              mapResponse({
                next: (reports) => offshoreReportsEvents.fetchReportsSuccess(reports),
                error: (error) => offshoreReportsEvents.fetchReportsFailed(error as Error),
              })
            )
          )
        ),
        openReport$: events.on(offshoreReportsEvents.openReport).pipe(
          tap(({ payload: { vesselId, reportId } }) => {
            router.navigate([`/site/${vesselId}/offshore-reports/${reportId}`]);
          })
        ),
      };
    })
  );
}
